const sidebar = {
  namespaced: true,
  state: {
    sidebarCollapsed: true,
    sidebarCollapsedMobile: true,
    initializationPage: false,
    orientation: 'landscape',
  },
  getters: {
    initPage: state => state.initializationPage,
    collapsed: state => state.sidebarCollapsed,
    collapsedMobile: state => state.sidebarCollapsedMobile,
    orientation: state => state.orientation,
  },
  mutations: {
    SET_INITIALIZATION_PAGE(state, value) {
      state.initializationPage = value;
    },
    SET_SIDEBAR_COLLAPSED(state, value) {
      state.sidebarCollapsed = value;
    },
    SET_SIDEBAR_COLLAPSED_MOBILE(state, value) {
      state.sidebarCollapsedMobile = value;
    },
    SET_ORIENTATION(state, value) {
      state.orientation = value;
    }
  }
};

export default sidebar;
